import { createRouter, createWebHistory } from 'vue-router';

const TelaCarregamento = () => import('../views/TelaCarregamento.vue');
const TelaLoginManager = () => import('../views/TelaLoginManager.vue');
const PedidosComercial = () => import('../views/comercial/PedidosComercial.vue');
const PedidosComercialPesaveis = () => import('../views/comercial/PedidosComercialPesaveis.vue');
const HistoricoRebaixas = () => import('../views/comercial/HistoricoRebaixas.vue');

const routes = [
    {
        path: '/',
        name: 'login',
        component: TelaLoginManager,
        meta: {
            title: 'semHeader',
            hasArrow: false,
            hasNoRefresh: true,
            isLogin: true,
        },
    },
    {
        path: '/pedidos/comercial',
        name: 'pedidos.comercial',
        component: PedidosComercial,
        meta: {
            title: 'Solicitações de Rebaixa para Aprovação',
            hasArrow: false,
            hasNoRefresh: true,
            Refresh: true,
            hasMenu: true,
        },
    },
    {
        path: '/historico/comercial',
        name: 'historico.comercial',
        component: HistoricoRebaixas,
        meta: {
            title: 'Histórico de Rebaixas Solicitadas',
            hasArrow: false,
            hasNoRefresh: true,
            Refresh: true,
            hasMenu: true,
            isSave: true,
        },
    },
    {
        path: '/pedidos/comercial/pesaveis',
        name: 'pedidos.comercial.pesaveis',
        component: PedidosComercialPesaveis,
        meta: {
            title: 'Solicitações de Rebaixas Pesáveis para Aprovação',
            hasArrow: false,
            hasNoRefresh: true,
            Refresh: true,
            hasMenu: true,
        },
    },
    {
        path: '/carregamento',
        name: 'carregamento',
        component: TelaCarregamento,
        meta: { title: 'semHeader', hasArrow: false, hasNoRefresh: true },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
});

router.beforeEach((to, from, next) => {
    let currentRoute = to.name;

    if (currentRoute == 'login') {
        if (currentRoute == 'login') {
            next();
        } else {
            router.push({ name: 'login' });
        }
    } else if (currentRoute !== 'login') {
        let user = sessionStorage.getItem('usuario');

        if (user) {
            next();
        } else {
            router.push({ name: 'login' });
        }
    } else {
        next();
    }
});

export default router;
